import * as React from 'react';

function ToggleablePanel({
  id,
  panelVisible,
  toggleText,
  children,
  onToggleChange,
}: {
  id: string;
  panelVisible: boolean;
  toggleText: string;
  children: React.ReactNode;
  onToggleChange: (toggleChecked: boolean) => void;
}) {
  return (
    <div id={id}>
      <div className="form-check mb-4">
        <input
          type="checkbox"
          checked={panelVisible}
          onChange={(event) => {
            onToggleChange(event.target.checked);
          }}
          className="form-check-input"
          id={`${id}-checkbox`}
        />
        <label className="form-check-label fw-normal" htmlFor={`${id}-checkbox`}>
          {toggleText}
        </label>
      </div>
      <div hidden={!panelVisible}>{children}</div>
    </div>
  );
}

export default ToggleablePanel;
